import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { AddUsersAction, DeleteUsersAction, GetAllUsersAction, USERS_TYPES } from './usersTypes';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import * as Actions from './usersActions';
import { IUsersGetResponse } from '../model/usersModel';
import { usersApi } from '../api/usersApi';

function* addUsersSaga(add: AddUsersAction) {
  try {
    yield put(Actions.setApiUsersRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<IUsersGetResponse> = yield call(usersApi.post, add.payload.users);

    yield put(Actions.getOneUsersSuccess(response.data));
    yield put(Actions.setApiUsersRequestState(API_REQUEST_STATE.SUCCEEDED_ADD));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiUsersRequestError(error.response.data.detail));
    yield put(Actions.setApiUsersRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.error('SAGA ERROR', error.response);
  }
}

function* deleteUsersSaga(edit: DeleteUsersAction) {
  try {
    yield put(Actions.setApiUsersRequestState(API_REQUEST_STATE.LOADING));

    yield call(usersApi.delete, edit.payload.params);

    yield put(Actions.setApiUsersRequestState(API_REQUEST_STATE.SUCCEEDED_DELETE));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiUsersRequestError(error.response.data.detail));
    yield put(Actions.setApiUsersRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.error('SAGA ERROR', error.response);
  }
}

function* getAllUsersSaga(getAll: GetAllUsersAction) {
  try {
    yield put(Actions.setApiAllUsersRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<IUsersGetResponse[]> = yield call(usersApi.getAll);

    yield put(Actions.setApiAllUsersRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getAllUsersSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiAllUsersRequestError(error.response.data.detail));
    yield put(Actions.setApiAllUsersRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.error('SAGA ERROR', error.response);
  }
}

export default function* watch() {
  yield* [
    takeLatest(USERS_TYPES.ADD, addUsersSaga),
    takeLatest(USERS_TYPES.DELETE, deleteUsersSaga),
    takeLatest(USERS_TYPES.GET_ALL, getAllUsersSaga),
  ];
}
